import { Injectable } from '@angular/core';
import
{
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AuthUtils } from './auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
  /**
   * Constructor
   */
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) { }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>>
  {
    // Clone the request object
    let newReq = req.clone();
    const isApiUrl = req.url.indexOf('/api/') !== -1;

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if (
      this._authService.accessToken &&
      isApiUrl &&
      !AuthUtils.isTokenExpired(this._authService.accessToken)
    )
    {
      newReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this._authService.accessToken
        ),
      });
    }

    // Response
    return next.handle(newReq).pipe(
      catchError(error =>
      {
        // Backend 401 Unauthorized: localStoragedagi tokenni o'chirib, loginga (OneID) yo'naltirish
        if (error instanceof HttpErrorResponse && error.status === 401)
        {
          this._authService.signOut();
          
          this._authService.goToOneIDPage('/');
        }

        return throwError(() => {
          return error;
        });
      })
    );
  }
}
